export default __webpack_public_path__ + "static/media/contrato1.308a5704.jpeg";